import { z } from 'zod'

export const TransferOutStatus = z.enum(['pending', 'approved', 'denied', 'expired', 'completed'])
export type TransferOutStatus = z.infer<typeof TransferOutStatus>

export const TransferOutRequest = z.object({
  id: z.number(),
  domain_name: z.string(),
  domain_id: z.number().nullable().optional(),
  status: TransferOutStatus,
  inwx_status: z.string().optional(),
  detected_at: z.number(),
  responded_at: z.number().nullable().optional(),
  expires_at: z.number().nullable().optional(),
  gaining_registrar: z.string().nullable().optional()
})
export type TransferOutRequest = z.infer<typeof TransferOutRequest>

export const TransferOutListResponse = z.object({
  requests: z.array(TransferOutRequest),
  total_count: z.number(),
  limit: z.number(),
  offset: z.number()
})
export type TransferOutListResponse = z.infer<typeof TransferOutListResponse>

export const TransferOutCountResponse = z.object({
  count: z.number()
})
export type TransferOutCountResponse = z.infer<typeof TransferOutCountResponse>

export const TransferOutApproveRequest = z.object({
  otp: z.string().optional()
})
export type TransferOutApproveRequest = z.infer<typeof TransferOutApproveRequest>

export const OtpRequiredError = z.object({
  error: z.enum(['totp_required', 'otp_required'])
})
export type OtpRequiredError = z.infer<typeof OtpRequiredError>
